import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const HomeIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg viewBox="0 0 101 114" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 114V38L50.5 0L101 38V114H63.125V69.6667H37.875V114H0Z"
        fill="currentColor"
      />
    </svg>
  </StyledSvgIcon>
);
export default HomeIcon;

HomeIcon.propTypes = customIconsPropTypes;
